import { twemojiAssetUrl } from '../utils/twemoji'

interface Props {
  emoji: string
  alt?: string
  className?: string
}

export function TwemojiImg({ emoji, alt, className }: Props) {
  return <img src={twemojiAssetUrl(emoji)} alt={alt ?? emoji} class={className} draggable={false} />
}
